import css from 'styled-jsx/css';
import { pageWidth } from 'styles/css-constants';

export default css`
  .Spread__item--ad {
    margin: 0.5rem 0 1.5rem;
  }

  .Spread__item--teaser {
    margin-bottom: 1rem;
  }

  .Spread__items {
    padding: 0 0.5rem;
  }

  @media (max-width: 47.99rem) {
    .Spread__item--teaser {
      margin-bottom: 3rem;
    }
  }

  @media (min-width: 48rem) {
    .Spread__item {
      margin: 0;
    }

    .Spread__items {
      padding: 0 1.5rem;
      column-count: 2;
      column-gap: 1.5rem;
    }
  }

  @media (min-width: 64rem) {
    .Spread__items {
      margin: 0 auto;
      width: ${pageWidth.large};
      padding: 0;
      column-count: 3;
    }

    @include large {
      .Spread__items {
      }
    }
  }

  @supports (display: grid) {
    @media (min-width: 48rem) and (max-width: 63.99rem) {
      .Spread__items {
        grid-column-gap: 1.5rem;
        grid-row-gap: 2.25rem;
        grid-template-columns: 0px repeat(2, 1fr) 0px;
        padding: 0;
        column-count: unset;
      }

      .Spread__item--ad {
        grid-column: span 4;
      }

      .Spread__item--teaser {
        max-width: none;
        padding: 0;
      }

      .Spread__item--teaser:nth-child(2n + 1) {
        grid-column-start: 2;
      }
    }

    @media (min-width: 64rem) {
      .Spread__items {
        grid-column-gap: 1.5rem;
        grid-row-gap: 2.25rem;
        grid-template-columns:
          1fr repeat(3, calc((${pageWidth.large} - 48px) / 3))
          1fr;
        padding: 0;
        column-count: unset;
        width: 100%;
        margin: 0;
      }

      .Spread__item--ad {
        grid-column: span 5;
      }

      .Spread__item--teaser {
        max-width: none;
        padding: 0;
      }

      .Spread__item--teaser:nth-child(3n + 1) {
        grid-column-start: 2;
      }
    }

    @media (min-width: 75rem) {
      .Spread__items {
        grid-template-columns:
          1fr repeat(3, calc((${pageWidth.midlarge} - 48px) / 3))
          1fr;
      }
    }
  }
`;
